var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Content',{staticClass:"col-span-full",attrs:{"title":_vm.$route.name,"showAdd":false,"pagination":{
    count: _vm.tableData.count,
    current: +_vm.$route.query.p,
    request: "geofences/events/",
  }},on:{"tableData":function($event){_vm.tableData = $event},"loading":function($event){_vm.loading = $event}}},[_c('ruleTable',{attrs:{"tableData":_vm.tableData,"alpha":_vm.alphaList,"type":_vm.activeName,"loading":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }